import { ProductImages } from "@components/commerce/product/image/ProductImages";
import { ProductImagesCarousel } from "@components/commerce/product/image/ProductImagesCarousel";
import type { Image } from "@graphql/generated/components";
import type { ImageWithVideo } from "@pages/product/[productName]/[articleNumber]/[colorCode]";
import { Box } from "@ui/components/layout/box/Box";
import dynamic from "next/dynamic";
import type { FC } from "react";
import { useCallback, useState } from "react";
import ProductImagesThumbnails from "./ProductImagesThumbnails";

const ProductImagesGallery = dynamic(
    () => import("@components/commerce/product/image/gallery/ProductImagesGallery"),
    { ssr: false }
);

interface IProductImagesContainerProps {
    images: Image[] | ImageWithVideo[];
    imageBackgroundColor?: string;
    altTagPattern?: string;
}

export const ProductImagesContainer: FC<IProductImagesContainerProps> = ({
    images,
    imageBackgroundColor,
    altTagPattern,
}) => {
    const [imageIndex, setImageIndex] = useState<number>(0);
    // @TODO: We should align with UX team about show more button/functionality, otherwise we need to clean up.
    const [isGalleryOpened, setIsGalleryOpened] = useState<boolean>(false);

    const onImageClick = useCallback((imageIndex: number) => {
        setImageIndex(imageIndex);
        setIsGalleryOpened(true);
    }, []);

    return (
        <>
            <Box
                display={["none", "none", "none", "block"]}
                zIndex={3}
                position="absolute"
                left={5}
                top={16}
                bottom={4}
                h="auto"
                w={12}
            >
                <ProductImagesThumbnails
                    images={images}
                    setImageIndex={setImageIndex}
                    imageIndex={imageIndex}
                    altTagPattern={altTagPattern}
                />
            </Box>
            <Box w="100%" aspectRatio={"4/5"} mt={[3, 3, 3, -16]} pos={"sticky"} top={0}>
                <ProductImages
                    images={images}
                    onImageClick={onImageClick}
                    imageBackgroundColor={imageBackgroundColor}
                    imageIndex={imageIndex}
                    altTagPattern={altTagPattern}
                />
                <ProductImagesCarousel
                    images={images}
                    onImageClick={onImageClick}
                    imageBackgroundColor={imageBackgroundColor}
                    altTagPattern={altTagPattern}
                />
                {isGalleryOpened ? (
                    <ProductImagesGallery
                        images={images}
                        onClose={() => {
                            setIsGalleryOpened(false);
                        }}
                        setSelectedImageIndex={setImageIndex}
                        selectedImageIndex={imageIndex}
                        imageBackgroundColor={imageBackgroundColor}
                        altTagPattern={altTagPattern}
                        imageIndex={imageIndex}
                    />
                ) : null}
            </Box>
        </>
    );
};

export default ProductImagesContainer;
